import { render } from "./Goods.vue?vue&type=template&id=64734919&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=64734919&scoped=true&lang=css"
import "./Goods.vue?vue&type=style&index=1&id=64734919&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64734919"]])

export default __exports__